const BASE_URL = 'https://glip.gg/wallet-login/';


const WEB_SOCKET_URI = 'https://be.namasteapis.com/wallet';

const LOGIN_TYPE_GOOGLE = "google";
const LOGIN_TYPE_EMAIL = "email";
const SUPPORTED_LOGIN_TYPES = [
    LOGIN_TYPE_GOOGLE, LOGIN_TYPE_EMAIL];

let VERIFIER_DICT:any = {
    [LOGIN_TYPE_GOOGLE]: {
        //all names are save...need to remove this
        "testnet": "glipgg-google-testnet",
        "mainnet": "glipgg-google-testnet",
        "cyan": "glipgg-google-testnet",
        "name": "Google",
        "clientId": "373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com",
        "typeOfLogin": 'google'        
    },
    [LOGIN_TYPE_EMAIL]: {
        "testnet":"glipgg-google-testnet",
        "mainnet":"glipgg-google-mainnet"
    }
}

export {BASE_URL, WEB_SOCKET_URI, LOGIN_TYPE_EMAIL,
        LOGIN_TYPE_GOOGLE, VERIFIER_DICT, SUPPORTED_LOGIN_TYPES};
